<template>
    <b-modal id="bv-modal-example" hide-footer>
      <template #modal-title>Confirmation</template>

  <div class="px-3 py-3 bg-white rounded">
      <div class="row">
        <div class="col">
            <label class="form-label pt-0 mb-2" for="dealer-name">{{project.title}} - {{ formattedPrice(project.budget) }}</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          {{project.description}}
        </div>
      </div>
  </div>

<div class="row">
  <div class="col">
    <label class="form-label text-white">Business name</label>
    <input type="text" placeholder="Enter business name" class="form-control" v-model="business_name">
  </div>
    
  </div>

      <div class="row pt-3 pb-2">
        <div class="col">
        <button type="button" class="btn btn-dark submit col" @click="hideModal">Cancel</button>
        </div>
        <div class="col">
        <button type="button" class="btn btn-danger submit col" @click="createProject()">Create project</button>
        </div>
      </div>

    </b-modal>
</template> 

<script>
export default {
  props: ['project'],

  data() {
    return {
      business_name: null,
      originalDescription: null,
    };
  },

  created() {
    this.originalDescription = this.project.description;
  },

  methods: {

    createProject() {
        if (!this.business_name) {this.sweetfire('Please enter business name for logo')}
        else {
        this.project.description = this.project.description + ' My business name is ' + this.business_name;
        this.$emit('create-project', this.project);
        this.hideModal();
        }
    },

    hideModal() {
      this.$bvModal.hide("bv-modal-example");
    },

    sweetfire(text) {
      Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: "Ok",
        customClass: {
          title: "popup-title",
        },
      });
    },

  },

}
</script>


<style scoped>
input.form-control {
  border-radius: 5px !important;
  background-color: #fff;
  border: 1px solid #1d1d1d;
  color: #1d1d1d;
}

.btn {
    border-radius: 5px !important;
}
</style>